document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("hamburger").addEventListener("click", function () {
    document.getElementById("slide").classList.add("show");
  });

  document.getElementById("slideRemove").addEventListener("click", function () {
    document.getElementById("slide").classList.remove("show");
  });

  const topNewsSwiper = new Swiper("#topNews", {
    direction: "vertical",
    effect: "slide",
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
  });

  if (document.getElementById("collectionSlider") !== null) {
    const collectionSlider = new Swiper("#collectionSlider", {
      loop: true,
      effect: "fade",
      slidesPerView: 1,
      speed: 1000,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: "#collection-pagination",
        clickable: true,
      },
    });
  }

  if (document.getElementById("rankSlider") !== null) {
    const rankSlider = new Swiper("#rankSlider", {
      loop: true,
      slidesPerView: 2,
      speed: 1000,
      spaceBetween: 15,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 38,
        },
      },
      pagination: {
        el: "#rank-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#rank-next",
        prevEl: "#rank-prev",
      },
    });
  }

  if (document.getElementById("purchaseHistorySlider") !== null) {
    const purchaseHistorySlider = new Swiper("#purchaseHistorySlider", {
      slidesPerView: 2,
      speed: 1000,
      spaceBetween: 15,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 38,
        },
      },
      pagination: {
        el: "#purchaseHistory-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#purchaseHistory-next",
        prevEl: "#purchaseHistory-prev",
      },
    });
  }

  if (document.querySelectorAll(".collectionSearch").length) {
    document.querySelectorAll(".searchTab").forEach((element) => {
      element.addEventListener("click", function () {
        if (window.matchMedia("(min-width: 768px)").matches) {
          document.querySelectorAll(".searchTab").forEach((elm) => {
            elm.classList.remove("current");
          });

          document.querySelectorAll(".searchTab").forEach((elm) => {
            if (element.dataset.targetId == elm.dataset.targetId) {
              elm.classList.add("current");
            }
          });

          document.querySelectorAll(".collectionSearch__items").forEach((elm) => {
            elm.classList.remove("current");
          });

          document.querySelectorAll(".collectionSearch__items").forEach((elm) => {
            if (element.dataset.targetId == elm.dataset.id) {
              elm.classList.add("current");
            }
          });
        } else {
          const elm = element.nextElementSibling;
          elm.classList.toggle("open");
          if (elm.classList.contains("open")) {
            elm.style.height = `${elm.scrollHeight}px`;
          } else {
            elm.style.height = "0";
          }
        }
      });
    });

    document.querySelectorAll(".collectionSearchParent").forEach((element) => {
      element.addEventListener("click", function () {
        const elm = element.nextElementSibling;
        elm.classList.toggle("open");
        if (elm.classList.contains("open")) {
          elm.style.height = `${elm.scrollHeight}px`;
          if (window.matchMedia("(max-width: 767px)").matches) {
            const parent = element.parentElement.parentElement;
            parent.style.height = `${parent.scrollHeight + elm.scrollHeight}px`;
          }
        } else {
          elm.style.height = "0";
          if (window.matchMedia("(max-width: 767px)").matches) {
            const parent = element.parentElement.parentElement;
            parent.style.height = `${parent.scrollHeight - elm.scrollHeight}px`;
          }
        }
      });
    });

    document.querySelectorAll(".collectionSearchPlus").forEach((element) => {
      element.addEventListener("click", function () {
        const elm = element.parentElement.nextElementSibling;
        elm.classList.toggle("open");
        if (elm.classList.contains("open")) {
          elm.style.height = `${elm.scrollHeight}px`;

          if (window.matchMedia("(max-width: 767px)").matches) {
            const parent1 = element.parentElement.parentElement;
            const parent2 = element.parentElement.parentElement.parentElement.parentElement;
            parent1.style.height = `${parent1.scrollHeight + elm.scrollHeight}px`;
            parent2.style.height = `${parent2.scrollHeight + elm.scrollHeight}px`;
          } else {
            elm.parentElement.style.height = `${elm.parentElement.scrollHeight + elm.scrollHeight}px`;
          }
        } else {
          elm.style.height = "0";
          if (window.matchMedia("(max-width: 767px)").matches) {
            const parent1 = element.parentElement.parentElement;
            const parent2 = element.parentElement.parentElement.parentElement.parentElement;
            parent1.style.height = `${parent1.scrollHeight - elm.scrollHeight}px`;
            parent2.style.height = `${parent2.scrollHeight - elm.scrollHeight}px`;
          } else {
            elm.parentElement.style.height = `${elm.parentElement.scrollHeight - elm.scrollHeight}px`;
          }
        }
      });
    });
  }

  ["headerSearchIcon", "headerSearchIconSp"].forEach((id) => {
    document.getElementById(id).addEventListener("click", function () {
      document.getElementById("headerSearch").classList.add("show");
    });
  });

  document.getElementById("headerSearchRemove").addEventListener("click", function () {
    document.getElementById("headerSearch").classList.remove("show");
  });

  if (document.getElementById("sortForm") !== null) {
    let urlParam = location.search.substring(1);

    if (urlParam) {
      let param = urlParam.split("&");
      let paramArray = [];
      for (i = 0; i < param.length; i++) {
        let paramItem = param[i].split("=");
        paramArray[paramItem[0]] = paramItem[1];
      }

      if (paramArray.sort_by) {
        document.querySelector(`option[value="${paramArray.sort_by}"]`).selected = true;
      }
    }
  }
});

if (document.getElementById("purchaseHistorySlider")) {
  setTimeout(() => {
    const parentHeight = document.getElementById("purchaseHistorySlider").clientHeight;
    document.querySelectorAll(".items__box.swiper-slide").forEach((element) => {
      element.style.height = `${parentHeight}px`;
    });
  }, 500);
}

if (document.getElementById("rankSlider")) {
  setTimeout(() => {
    const parentHeight = document.getElementById("rankSlider").clientHeight;
    document.querySelectorAll(".items__box.swiper-slide").forEach((element) => {
      element.style.height = `${parentHeight}px`;
    });
  }, 500);
}

if (document.getElementById("checkoutCheck")) {
  document.getElementById("checkoutCheckInput").addEventListener("change", function () {
    if (document.getElementById("checkoutCheckInput").checked) {
      document.getElementById("checkout").disabled = false;
      document.getElementById("checkoutCheckError").style.display = "none";
    } else {
      document.getElementById("checkout").disabled = true;
      document.getElementById("checkoutCheckError").style.display = "block";
    }
  });

  document.querySelectorAll(".cart-submit-btn").forEach((element) => {
    element.addEventListener("click", function () {
      document.getElementById("cartPolicyCheck").classList.add("show");
    });

    document.getElementById("cartPolicyCheckClose").addEventListener("click", function () {
      document.getElementById("cartPolicyCheck").classList.remove("show");
    });
  });
}

if (document.getElementById("langChange")) {
  const lang = document.getElementById("langChange").dataset.lang;

  document.querySelectorAll(".langChangeJp").forEach((element) => {
    if (lang == "en") {
      element.href = location.href.replace("ginkawaten.shop", "ginkawaten.co.jp");
    }

    if (lang == "zh-CN") {
      element.href = location.href.replace("ginkawaten.shop/zh-cn", "ginkawaten.co.jp");
    }
  });

  document.querySelectorAll(".langChangeEn").forEach((element) => {
    if (lang == "ja") {
      element.href = location.href.replace("ginkawaten.co.jp", "ginkawaten.shop");
    }

    if (lang == "zh-CN") {
      element.href = location.href.replace("ginkawaten.shop/zh-cn", "ginkawaten.shop");
    }
  });

  document.querySelectorAll(".langChangeCn").forEach((element) => {
    if (lang == "en") {
      element.href = location.href.replace("ginkawaten.shop", "ginkawaten.shop/zh-cn");
    }

    if (lang == "ja") {
      element.href = location.href.replace("ginkawaten.co.jp", "ginkawaten.shop/zh-cn");
    }
  });
}

if (document.getElementById("bloomRemoval")) {
  document.querySelectorAll(".bloomRemovalClose").forEach((el) => {
    el.addEventListener("click", () => document.getElementById("bloomRemoval").classList.add("hide"));
  });
}

if (document.getElementById("preOrderSlider")) {
  new Swiper("#preOrderSlider", {
    slidesPerView: 2,
    speed: 1000,
    spaceBetween: 15,

    autoplay: {
      delay: 3000,
    },

    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 38,
      },
    },

    pagination: {
      el: "#preOrder-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: "#preOrder-next",
      prevEl: "#preOrder-prev",
    },
  });
}

if (document.getElementById("freePriceRest")) {
  document.getElementById("freePriceRest").textContent = Number(document.getElementById("freePriceRest").textContent).toLocaleString();
}
